import { Subject } from 'rxjs';

import { Corner, HTMLUtils } from '../../../../utils/html.utils';
import { ImageContainer } from './image-container';
import { Resizer } from './move_resize_square';

export interface ResizableContainerBounds {
    left: number;
    top: number;
    width: number;
    height: number;
    top_percentage: number;
    left_percentage: number;
    width_percentage: number;
    height_percentage: number;
}

export interface ResizableContainerBoundsChangeEvent extends ResizableContainerBounds {
    /**
     * If the change caused by a mouse/touch move event then this value is true.
     * false if updated manually
     */
    isTrusted: boolean;
}

export class UIResizeSquare {
    _elements;
    resizable_element;
    parent;
    mousedown_info;
    container: ImageContainer;
    dim: ResizableContainerBounds;
    valueChanges: Subject<ResizableContainerBoundsChangeEvent>;

    isAspectLocked = true;
    resizer: Resizer;

    constructor(container, $parent) {
        this.container = container;
        this.resizable_element = this.container.getElement().querySelector('div#elementResizable');
        this.parent = $parent;
    }

    public getResizableElementId() {
        return this.resizable_element.id;
    }
    public getParentId() {
        return this.parent.id;
    }
    public getResizableElement(): HTMLElement {
        return this.resizable_element;
    }
    public getParent() {
        return this.parent;
    }
    public getContent() {
        return this._elements;
    }
    // Expect a dim object with ratio and constant side;
    public resize(dim) {
        let width = this.getResizableElement().getBoundingClientRect().width;
        let height = this.getResizableElement().getBoundingClientRect().height;
        if (dim.constant_side == 'WIDTH') {
            HTMLUtils.css(this.getResizableElement(), 'width', (dim.ratio * width) + 'px');
        } else {
            HTMLUtils.css(this.getResizableElement(), 'height', (dim.ratio * height) + 'px');
        }
    }
    public getArea() {
        return {
            top: this.getResizableElement().getBoundingClientRect().top,
            left: this.getResizableElement().getBoundingClientRect().left,
            width: this.getResizableElement().getBoundingClientRect().width,
            height: this.getResizableElement().getBoundingClientRect().height,
        };
    }
    public getParentArea() {
        return {
            top: this.getResizableElement().parentElement.getBoundingClientRect().top,
            left: this.getResizableElement().parentElement.getBoundingClientRect().left,
            width: this.getResizableElement().parentElement.getBoundingClientRect().width,
            height: this.getResizableElement().parentElement.getBoundingClientRect().height,
        };
    }
    public fitToContainer() {
        this.getResizableElement().style.top = '0';
        this.getResizableElement().style.left = '0';
        this.getResizableElement().style.width = '100%';
        this.getResizableElement().style.height = '100%';
        this.getResizableElement().style.backgroundSize = '100% 100%';
    }

    resizeMouseDown(e: MouseEvent & { target: HTMLElement, offsetY: any, offsetX: any }) {
        const xCanvas: HTMLElement = (e.target as HTMLElement).closest('#' + this.getResizableElementId()).parentElement.parentElement.querySelector('canvas#x');
        const xCanvasRect = xCanvas.getBoundingClientRect();
        let $element = document.getElementById(this.getResizableElementId());

        let handlerPosition: Corner = 'topleft';
        if (e.target.id === 'negrip') {
            handlerPosition = 'topright';
        } else if (e.target.id === 'swgrip') {
            handlerPosition = 'bottomleft';
        } else if (e.target.id === 'segrip') {
            handlerPosition = 'bottomright';
        }

        this.mousedown_info = {
            element: $element,
            handle: e.target,
            elementResizable: document.getElementById(this.getResizableElementId()),
            top: 0, // This and left should be set to offset from handler topleft current mousepoint
            left: 0,
            width: $element.getBoundingClientRect().width,
            height: $element.getBoundingClientRect().height,
            target: {
                element: (e.target).closest('#' + this.getResizableElementId()),
                top: (e.target.closest('#' + this.getResizableElementId()) as HTMLElement).getBoundingClientRect().top,
                left: (e.target.closest('#' + this.getResizableElementId()) as HTMLElement).getBoundingClientRect().left,
                width: parseFloat((e.target.closest('#' + this.getResizableElementId()) as HTMLElement).getBoundingClientRect().width + '') || 0,
                height: parseFloat((e.target.closest('#' + this.getResizableElementId()) as HTMLElement).getBoundingClientRect().height + '') || 0,
            },
            parent: {
                element: (e.target).closest('#' + this.getParentId()),
                top: (e.target.closest('#' + this.getParentId()) as HTMLElement).getBoundingClientRect().top,
                left: (e.target.closest('#' + this.getParentId()) as HTMLElement).getBoundingClientRect().left,
                width: parseFloat((e.target.closest('#' + this.getParentId()) as HTMLElement).getBoundingClientRect().width + '') || 0,
                height: parseFloat((e.target.closest('#' + this.getParentId()) as HTMLElement).getBoundingClientRect().height + '') || 0,
            },
            img: {
                width: parseFloat(xCanvasRect.width + '') || 0,
                height: parseFloat(xCanvasRect.height + '') || 0,
            },
            offset: HTMLUtils.getMouseOffset(xCanvas, e, handlerPosition),
            isAspectLocked: this.isAspectLocked, // TODO need to get it from UI
        };

        if (e.target.classList.contains('resize_handle')) {
            this.mousedown_info.event = 'RESIZE';
        } else {
            this.mousedown_info.event = 'MOVE';
        }
    }

    mouseMove(e) {
        // VVV HPY what is this? window.et = e;
        const pageX = e.pageX || e.touches[0].pageX;
        const pageY = e.pageY || e.touches[0].pageY;
        let mousemove_info = {
            // top : e.offsetY,
            // left: e.offsetX,
            abs_top: pageX,
            abs_left: pageX,
            new_top: (pageY - (this.mousedown_info.parent.top + this.mousedown_info.top)) - window.scrollY, // Distance from the top left coner to mouse
            //  click in pixels
            new_left: (pageX - (this.mousedown_info.parent.left + this.mousedown_info.left)) - window.scrollX, // Distance from the top left coner to mouse
            //  click in pixels
        };
        this.dim = {
            left: 100,
            top: 100,
            width: 100,
            height: 100,
            top_percentage: 0,
            left_percentage: 0,
            width_percentage: 0,
            height_percentage: 0,
        };
        if ((this.mousedown_info.handle as HTMLElement).classList.contains('nwgrip')) {
            // top left coner
            // 1. move top left to new position
            this.dim.top = mousemove_info.new_top;
            this.dim.left = mousemove_info.new_left;
            // 2. Resize box
            this.dim.width = this.mousedown_info.parent.width - 2 * mousemove_info.new_left;
            this.dim.height = this.mousedown_info.parent.height - 2 * (mousemove_info.new_top);

        } else if ((this.mousedown_info.handle as HTMLElement).classList.contains('negrip')) {
            // top right coner
            // 1. move top left to new position
            this.dim.left = this.mousedown_info.parent.width - mousemove_info.new_left;
            this.dim.top = mousemove_info.new_top;
            // 2. Resize box
            this.dim.width = this.mousedown_info.parent.width - 2 * (this.dim.left);
            this.dim.height = this.mousedown_info.parent.height - 2 * mousemove_info.new_top;
        } else if ((this.mousedown_info.handle as HTMLElement).classList.contains('swgrip')) {
            // top left coner
            // 1. move top left to new position
            this.dim.left = mousemove_info.new_left;
            this.dim.top = this.mousedown_info.parent.height - mousemove_info.new_top;

            // 2. Resize box
            this.dim.width = this.mousedown_info.parent.width - 2 * mousemove_info.new_left;
            this.dim.height = this.mousedown_info.parent.height - 2 * this.dim.top;
        } else if ((this.mousedown_info.handle as HTMLElement).classList.contains('segrip')) {
            // top right coner
            // 1. move top left to new position
            this.dim.left = this.mousedown_info.parent.width - mousemove_info.new_left;
            this.dim.top = this.mousedown_info.parent.height - mousemove_info.new_top;
            // 2. Resize box
            this.dim.width = this.mousedown_info.parent.width - 2 * (this.dim.left);
            this.dim.height = this.mousedown_info.parent.height - 2 * this.dim.top;
        }
        if (this.mousedown_info.isAspectLocked) {
            // recalculate top and height relative to left and width
            this.dim.height = this.dim.width * this.mousedown_info.img.height / this.mousedown_info.img.width;
            this.dim.top = (this.mousedown_info.parent.height - this.dim.height) / 2;
        } else {

        }

        // Convert to ratios
        this.updateDimPercentage();

        let w_conversion_factor = this.dim.width / this.mousedown_info.parent.width;
        let h_conversion_factor = this.dim.height / this.mousedown_info.parent.height;

        if (Math.round(this.mousedown_info.img.width * w_conversion_factor) > 6000 ||
            Math.round(this.mousedown_info.img.height * w_conversion_factor) > 6000) {
            return;
        }

        // mode = container.getCurrentEditorMode().mrs.getResizableElement()[0].getClientRects()[0];

        // $("#resize .width").val(Math.round(this.mousedown_info.img.width * w_conversion_factor));
        // $("#resize .height").val(Math.round(this.mousedown_info.img.height * w_conversion_factor));
        this.updateResizableContainer(true);
        this.valueChanges.next(Object.assign({}, this.dim, { isTrusted: true }));
        return;
        if (this.mousedown_info.event == 'RESIZE') {
            // this.resize_handler_(e, this.mousedown_info.elementResizable, mousemove_info, this.mousedown_info, directionToNumber($(this.mousedown_info.handle).data("direction")));
        } else if (this.mousedown_info.event = 'MOVE') {
            /*
            if(mousemove_info.new_top < 0){
                mousemove_info.new_top = 0;
            }
            if(mousemove_info.new_left < 0){
                mousemove_info.new_left = 0;
            }

            if(mousemove_info.new_top + this.mousedown_info.height > this.mousedown_info.parent.height){
                mousemove_info.new_top = this.mousedown_info.parent.height - this.mousedown_info.height;
            }
            if(mousemove_info.new_left + this.mousedown_info.width > this.mousedown_info.parent.width){
                mousemove_info.new_left = this.mousedown_info.parent.width - this.mousedown_info.width;
            }

            $($element).style.top = ", Math.round(mousemove_info.new_top) + "px");
            $($element).style.left = ",  Math.round(mousemove_info.new_left) + "px");
            */
        }
        // window.container.getCurrentEditorMode().UI_updateDimensionInputs();
        // $that.update_faded_area();
    }

    updateDimPercentage() {
        let _container = this.container.getElement().getBoundingClientRect();
        this.dim.top_percentage = this.dim.top * 100 / _container.height;
        this.dim.left_percentage = this.dim.left * 100 / _container.width;
        this.dim.width_percentage = this.dim.width * 100 / _container.width;
        this.dim.height_percentage = this.dim.height * 100 / _container.height;
    }

    getDim(): ResizableContainerBounds {
        return this.dim;
    }

    setDim(dim: ResizableContainerBounds): void {
        this.dim = dim;
    }

    emitFakeEvent() {
        this.valueChanges.next(Object.assign({}, this.dim, { isTrusted: false }));
    }

    updateResizableContainer(isTrusted?: boolean) {
        this.getResizableElement().style.top = this.dim.top_percentage + '%';
        this.getResizableElement().style.left = this.dim.left_percentage + '%';
        this.getResizableElement().style.width = this.dim.width_percentage + '%';
        this.getResizableElement().style.height = this.dim.height_percentage + '%';
        // this.getResizableElement().style.backgroundSize = ", Math.round(dim.width) + "px " + Math.round(dim.height) + "px");
        this.getResizableElement().style.backgroundSize = '100% 100%';
    }

    public init(valueChanges: Subject<ResizableContainerBoundsChangeEvent>) {
        this.valueChanges = valueChanges;
        // set initial position
        this.getResizableElement().style.top = 'calc(50% - 50px)';
        this.getResizableElement().style.left = 'calc(50% - 60px)';
        this.getResizableElement().style.width = 120 + 'px';
        this.getResizableElement().style.height = 100 + 'px';
        // init initial state
        this.update_faded_area();
        // Add events
    }
    public remove() {
        /*
        this.resizable_element.off();
        this.resizable_element.unbind();
        this.resizable_element.remove();

        $(".handle").off();
        $(".handle").remove();
        $(".grid").off();
        $(".grid").remove();
        */
    }

    public update_faded_area() {
        let parent_offset = this.getParentArea();
        let offset = this.getArea();
        let dim = {
            width: this.getArea().width,
            height: this.getArea().height,
        };
        let parent_dim = {
            width: this.getParentArea().width,
            height: this.getParentArea().height,
        };
        document.getElementById('top').style.width = parent_dim.width + 'px';
        document.getElementById('top').style.height = (offset.top - parent_offset.top) + 'px';

        document.getElementById('left').style.top = (offset.top - parent_offset.top) + 'px';
        document.getElementById('left').style.left = parent_offset.left - parent_offset.left + 'px';
        document.getElementById('left').style.width = (offset.left - parent_offset.left) + 'px';
        document.getElementById('left').style.height = parent_dim.height - (offset.top - parent_offset.top) + 'px';

        document.getElementById('right').style.top = (offset.top - parent_offset.top) + 'px';
        document.getElementById('right').style.left = offset.left + dim.width - parent_offset.left + 'px';
        document.getElementById('right').style.width = parent_dim.width - (offset.left - parent_offset.left + dim.width) + 'px';
        document.getElementById('right').style.height = parent_dim.height - (offset.top - parent_offset.top) + 'px';

        document.getElementById('bottom').style.top = (offset.top + dim.height - parent_offset.top) + 'px';
        document.getElementById('bottom').style.left = offset.left - parent_offset.left + 'px';
        document.getElementById('bottom').style.width = dim.width + 'px';
        document.getElementById('bottom').style.height = parent_dim.height - (offset.top - parent_offset.top + dim.height) + 'px';

        // ci = new cimage(c.image);
    }

    private resize_north(element, mousedown_info, mousemove_info) {
        let new_top = mousemove_info.new_top;
        let new_height = mousedown_info.height - (new_top - (mousedown_info.target.top - mousedown_info.parent.top));
        let isUpdateLeft = true;
        if (new_top <= 0) {
            new_height = new_height + new_top;
            new_top = 0;
        }

        if (new_height <= 10) {
            new_height = 10;
        }

        this.update_height_percent(element, 100 * new_height / element.parent().height());
        this.update_top(element, parseInt('' + Math.round(new_top)));
    }

    private resize_west(element, mousedown_info, mousemove_info) {
        let new_left = mousemove_info.new_left;
        let new_width = mousedown_info.width - (new_left - (mousedown_info.target.left - mousedown_info.parent.left));
        let isUpdateLeft = true;
        if (new_left <= 0) {
            new_width = new_width + new_left;
            new_left = 0;
        }

        if (new_width <= 10) {
            new_width = 10;
        }
        this.update_width_percent(element, 100 * new_width / element.parent().width());
        this.update_left(element, parseInt('' + Math.round(new_left)));
    }
    private resize_south(element, mousedown_info, mousemove_info) {
        let new_top = mousemove_info.new_top;
        let new_height = (new_top - (mousedown_info.target.top - mousedown_info.parent.top));
        if (new_height < 10) {
            new_height = 10;
        }
        if (new_height + (mousedown_info.target.top - mousedown_info.parent.top) > mousedown_info.parent.height) {
            new_height = mousedown_info.parent.height - (mousedown_info.target.top - mousedown_info.parent.top);
        }
        this.update_height_percent(element, 100 * new_height / element.parent().height());
    }
    private resize_east(element, mousedown_info, mousemove_info) {
        let new_left = mousemove_info.new_left;
        let new_width = (new_left - (mousedown_info.target.left - mousedown_info.parent.left));
        if (new_width < 10) {
            new_width = 10;
        }
        if (new_width + (mousedown_info.target.left - mousedown_info.parent.left) > mousedown_info.parent.width) {
            new_width = mousedown_info.parent.width - (mousedown_info.target.left - mousedown_info.parent.left);
        }
        this.update_width_percent(element, 100 * new_width / element.parent().width());
    }
    private resize_nw(element, mousedown_info, mousemove_info) {
        let new_top = mousemove_info.new_top;
        let new_height = mousedown_info.height - 2 * (new_top - (mousedown_info.target.top - mousedown_info.parent.top));
        let isUpdateLeft = true;

        this.update_height_percent(element, 100 * new_height / element.parent().height());
        this.update_top(element, parseInt('' + Math.round(new_top)));

        let new_left = mousemove_info.new_left;
        let new_width = mousedown_info.width - 2 * (new_left - (mousedown_info.target.left - mousedown_info.parent.left));

        this.update_width_percent(element, 100 * new_width / element.parent().width());
        this.update_left(element, parseInt('' + Math.round(new_left)));
    }
    private resize_ne(element, mousedown_info, mousemove_info) {
        let new_top = mousemove_info.new_top;
        let new_height = mousedown_info.height - 2 * (new_top - (mousedown_info.target.top - mousedown_info.parent.top));
        let isUpdateLeft = true;

        this.update_height_percent(element, 100 * new_height / element.parent().height());
        this.update_top(element, parseInt('' + Math.round(new_top)));

        let new_left = mousemove_info.new_left;
        let new_width = (new_left - (mousedown_info.target.left - mousedown_info.parent.left));

        if (new_width + (mousedown_info.target.left - mousedown_info.parent.left) > mousedown_info.parent.width) {
            new_width = mousedown_info.parent.width - (mousedown_info.target.left - mousedown_info.parent.left);
        }
        new_left = ((mousedown_info.parent.width - new_width) / 2);

        this.update_width_percent(element, 100 * new_width / element.parent().width());
        this.update_left(element, parseInt('' + Math.round(new_left)));
    }

    private resize_se(element, mousedown_info, mousemove_info) {
        let new_top: number = mousemove_info.new_top;
        let new_height = (new_top - (mousedown_info.target.top - mousedown_info.parent.top));
        if (new_height < 10) {
            new_height = 10;
        }
        if (new_height + (mousedown_info.target.top - mousedown_info.parent.top) > mousedown_info.parent.height) {
            new_height = mousedown_info.parent.height - (mousedown_info.target.top - mousedown_info.parent.top);
        }
        this.update_height_percent(element, 100 * new_height / element.parent().height());
        this.update_top(element, parseInt('' + Math.round(new_top)));

        let new_left = mousemove_info.new_left;
        let new_width = (new_left - (mousedown_info.target.left - mousedown_info.parent.left));
        if (new_width < 10) {
            new_width = 10;
        }
        if (new_width + (mousedown_info.target.left - mousedown_info.parent.left) > mousedown_info.parent.width) {
            new_width = mousedown_info.parent.width - (mousedown_info.target.left - mousedown_info.parent.left);
        }
        this.update_left(element, parseInt('' + Math.round(new_left)));
        this.update_width_percent(element, 100 * new_width / element.parent().width());
    }
    private resize_sw(element, mousedown_info, mousemove_info) {
        let new_top = mousemove_info.new_top;
        let new_height = (new_top - (mousedown_info.target.top - mousedown_info.parent.top));
        if (new_height < 10) {
            new_height = 10;
        }
        if (new_height + (mousedown_info.target.top - mousedown_info.parent.top) > mousedown_info.parent.height) {
            new_height = mousedown_info.parent.height - (mousedown_info.target.top - mousedown_info.parent.top);
        }
        this.update_height_percent(element, 100 * new_height / element.parent().height());

        let new_left = mousemove_info.new_left;
        let new_width = (new_left - (mousedown_info.target.left - mousedown_info.parent.left));
        if (new_width < 10) {
            new_width = 10;
        }
        if (new_width + (mousedown_info.target.left - mousedown_info.parent.left) > mousedown_info.parent.width) {
            new_width = mousedown_info.parent.width - (mousedown_info.target.left - mousedown_info.parent.left);
        }
        this.update_width_percent(element, 100 * new_width / element.parent().width());
    }

    private resize_horizontally(element, mousedown_info, mousemove_info) {

    }
    private resize_handler_(e, element, mousemove_info, mousedown_info, direction) {
        let direction_arr = {
            n: 1, ne: 2, e: 3, se: 4, s: 5, sw: 6, w: 7, nw: 8,
        };
        switch (direction) {
            case direction_arr.ne:
                this.resize_ne(element, mousedown_info, mousemove_info);
                // resize_north(element, mousedown_info, mousemove_info);
                // resize_east(element, mousedown_info, mousemove_info);
                break;
            case direction_arr.se:
                this.resize_se(element, mousedown_info, mousemove_info);
                // resize_east(element, mousedown_info, mousemove_info);
                // resize_south(element, mousedown_info, mousemove_info);
                break;
            case direction_arr.sw:
                this.resize_sw(element, mousedown_info, mousemove_info);
                // resize_west(element, mousedown_info, mousemove_info);
                // resize_south(element, mousedown_info, mousemove_info);
                break;
            case direction_arr.nw:
                this.resize_nw(element, mousedown_info, mousemove_info);
                // resize_north(element, mousedown_info, mousemove_info);
                // resize_west(element, mousedown_info, mousemove_info);
                break;
        }

    }
    private update_width(element, value) {
        element.style.width = value + 'px';
    }
    private update_height(element, value) {
        element.style.height = value + 'px';
    }
    private update_top(element, value) {
        element.style.top = value + 'px';
    }
    private update_left(element, value) {
        element.style.left = value + 'px';
    }
    private update_width_percent(element, value) {
        element.style.width = value + '%';
    }
    private update_height_percent(element, value) {
        element.style.height = value + '%';
    }
    private update_top_percent(element, value) {
        element.style.top = value + '%';
    }
    private update_left_percent(element, value) {
        element.style.left = value + '%';
    }
    private directionToNumber(direction) {
        let direction_arr = {
            n: 1, ne: 2, e: 3, se: 4, s: 5, sw: 6, w: 7, nw: 9,
        };
        return direction_arr[direction];
    }

    public getOverlayCanvas(): HTMLCanvasElement {
        return this.getResizableElement().querySelector('#overlayCanvas');
    }

}
